import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import FilterTags from './FilterTags'
import { actions } from '../../../store'

const mapStateToProps = state => ({
  filters: state.storage.filters,
  tags: state.tag.list
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getStorage: actions.storage.getStorage,
  setFilterMatchAllTags: actions.storage.setFilterMatchAllTags,
  setFilterMatchAnyTags: actions.storage.setFilterMatchAnyTags,
  setFilterMatchNoneTags: actions.storage.setFilterMatchNoneTags
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterTags)



// WEBPACK FOOTER //
// ./src/components/Parts/FilterTags/index.js